import {MessageCodes} from "../MessageCodes";
import ResultTable from "../../Table/ResultTable";
import ResultText from "../ResultText";
import CheckCSName from "../../CheckCSName";
import EmptyLine from "../../EmptyLine";
import ResultHeader from "../../Table/ResultHeader";
import ResultRow from "../../Table/ResultRow";
import ResultHeaderCell from "../../Table/ResultHeaderCell";
import ResultBody from "../../Table/ResultBody";
import ResultBodyCell from "../../Table/ResultBodyCell";
import HecRasHelper from "../../../Helpers/HecRasHelper";
const RenderDescription = ({text, row, settings, globalVariables}) => {
    switch (row.error_id) {
        case MessageCodes.Internal.BM001.error_id: {
            return (
                <>
                    {
                        row.data.map(x => {
                            return (
                                <ResultText>
                                    Bridge at RS <CheckCSName csName={x.cross_section} /> does not follow the suggested bridge modeling methods: {x.missing_methods}{x.multiple ? ` at multiple bridge opening #${x.number}` : ''}.
                                </ResultText>
                            )
                        })
                    }
                </>
            )
        }
        case MessageCodes.Internal.TBM002.error_id: {
            return (
                <>
                    <ResultText>
                        The maximum submergence ratio of {row.data.length} bridge structures at the following river stations are different than the default value {settings?.defaults?.max_submergence_ratio}
                        <EmptyLine />
                    </ResultText>
                    <ResultTable>
                        <ResultHeader>
                            <ResultRow>
                                <ResultHeaderCell style={{textAlign: 'left'}}>River Station</ResultHeaderCell>
                                <ResultHeaderCell style={{textAlign: 'right'}}>Max Submergence Ratio</ResultHeaderCell>
                            </ResultRow>
                        </ResultHeader>
                        <ResultBody>
                            {
                                row.data.map(r => (
                                    <ResultRow>
                                        <ResultBodyCell style={{textAlign: 'left', width: 125}}><CheckCSName csName={r.cross_section} /></ResultBodyCell>
                                        <ResultBodyCell style={{textAlign: 'right'}}>{HecRasHelper.isUndefined(r.ratio, '-')}</ResultBodyCell>
                                    </ResultRow>
                                ))
                            }
                        </ResultBody>
                    </ResultTable>
                </>
            )
        }
        case MessageCodes.Internal.TBM003.error_id: {
            return (
                <>
                    <ResultText>
                        The maximum submergence ratio of {row.data.length} culvert structures at the following river stations are different than the default value {settings?.defaults?.max_submergence_ratio}
                        <EmptyLine />
                    </ResultText>
                    <ResultTable>
                        <ResultHeader>
                            <ResultRow>
                                <ResultHeaderCell style={{textAlign: 'left'}}>River Station</ResultHeaderCell>
                                <ResultHeaderCell style={{textAlign: 'right'}}>Max Submergence Ratio</ResultHeaderCell>
                            </ResultRow>
                        </ResultHeader>
                        <ResultBody>
                            {
                                row.data.map(r => (
                                    <ResultRow>
                                        <ResultBodyCell style={{textAlign: 'left', width: 125}}><CheckCSName csName={r.cross_section} /></ResultBodyCell>
                                        <ResultBodyCell style={{textAlign: 'right'}}>{HecRasHelper.isUndefined(r.ratio, '-')}</ResultBodyCell>
                                    </ResultRow>
                                ))
                            }
                        </ResultBody>
                    </ResultTable>
                </>
            )
        }
        default: {
            return `Error Key Not Found: ${row.error_id}`
        }
    }
}

export const B7 = {
    RenderDescription,

}